import { createApp } from 'vue'
import PercentageIncrease from './PercentageIncrease.vue'
import './assets/global.css'

createApp(PercentageIncrease).mount('#percentage-increase')
